/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateActivationsControllerRestoreDefaultsMutationRequest, TemplateActivationsControllerRestoreDefaultsMutationResponse, TemplateActivationsControllerRestoreDefaults401, TemplateActivationsControllerRestoreDefaults403, TemplateActivationsControllerRestoreDefaults404 } from "../../models/checklistsController/TemplateActivationsControllerRestoreDefaults";

function getTemplateActivationsControllerRestoreDefaultsUrl() {
  const res = { method: 'POST', url: `/api/v1/checklist-template-activations/restore-defaults` as const }  
  return res
}

/**
 * @summary Restore team activations to org defaults (soft-delete all team overrides)
 * {@link /api/v1/checklist-template-activations/restore-defaults}
 */
export async function templateActivationsControllerRestoreDefaults(data?: TemplateActivationsControllerRestoreDefaultsMutationRequest, config: Partial<RequestConfig<TemplateActivationsControllerRestoreDefaultsMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TemplateActivationsControllerRestoreDefaultsMutationResponse, ResponseErrorConfig<TemplateActivationsControllerRestoreDefaults401 | TemplateActivationsControllerRestoreDefaults403 | TemplateActivationsControllerRestoreDefaults404>, TemplateActivationsControllerRestoreDefaultsMutationRequest>({ method : "POST", url : getTemplateActivationsControllerRestoreDefaultsUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}